import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarAgendaCompromissoFiscal, setModalDeletarAgendaCompromissoFiscal } from "../redux/slices/agendaCompromissoFiscal/agendaCompromissoFiscalSlice";

export const cadastrarAgenda = createAsyncThunk("/Agenda/CadastrarAgenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/Agenda/CadastrarAgenda", payload.value);
    toastSucess("Agenda cadastrada com sucesso");
    dispatch(setModalCadastrarAgendaCompromissoFiscal(false));
    dispatch(setLoading(false));

    dispatch(buscarAgenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarAgenda = createAsyncThunk("/Agenda/BuscarAgenda", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/Agenda/BuscarAgenda", {
      params: { Id: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarAgenda = createAsyncThunk("/Agenda/AtualizarAgenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/Agenda/AtualizarAgenda", payload.value);
    toastSucess("Agenda atualizada com sucesso");
    dispatch(setModalCadastrarAgendaCompromissoFiscal(false));
    dispatch(setLoading(false));

    dispatch(buscarAgenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarAgenda = createAsyncThunk("/Agenda/DeletarAgenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/Agenda/DeletarAgenda/?id=" + payload.value);
    toastSucess("Agenda removida com sucesso");
    dispatch(setModalDeletarAgendaCompromissoFiscal(false));
    dispatch(setLoading(false));

    dispatch(buscarAgenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
